// Версия подставляется на этапе сборки из package.json (см. next.config.ts),
// поэтому отображается и в dev-, и в продакшн-режиме.
const APP_VERSION = (process.env.NEXT_PUBLIC_APP_VERSION || "").replace(/\.0$/, "");

export function Logo() {
  return (
    <div className="relative w-full overflow-visible">
      <img
        src="/images/logo/logo-light.png"
        className="block h-auto w-full max-w-full dark:hidden"
        alt="OTAN ERP logo"
        loading="eager"
        decoding="async"
      />
      <img
        src="/images/logo/logo-dark.png"
        className="hidden h-auto w-full max-w-full dark:block"
        alt="OTAN ERP logo"
        loading="eager"
        decoding="async"
      />

      {APP_VERSION && (
        <p className="mt-1 text-right text-xs text-dark-5 dark:text-dark-6">
          v{APP_VERSION}
        </p>
      )}
    </div>
  );
}
